var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Actividades para expediente " + _vm.file.numero,
        centered: "",
        "hide-footer": ""
      },
      on: {
        close: function($event) {
          return _vm.closeModal()
        }
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", [
        _c("div", { staticClass: "row mb-3" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "chip-custom" }, [
              _vm._v(
                " Acá podrás ver el detalle de las actividades registradas a este expediente... despliega sobre el usuario que quieras ver la información "
              )
            ]),
            _c(
              "div",
              { staticClass: "my-3 order" },
              [
                _vm._v(" Ordenar por usuarios "),
                _c("vs-switch", {
                  staticClass: "ml-3",
                  model: {
                    value: _vm.sortByUsers,
                    callback: function($$v) {
                      _vm.sortByUsers = $$v
                    },
                    expression: "sortByUsers"
                  }
                })
              ],
              1
            ),
            _vm.sortByUsers
              ? _c(
                  "div",
                  { staticClass: "py-2 box-activities" },
                  [
                    _c(
                      "vs-collapse",
                      { attrs: { accordion: "" } },
                      _vm._l(Object.keys(_vm.activitiesHistory), function(
                        activityUser,
                        index
                      ) {
                        return _c(
                          "vs-collapse-item",
                          { key: index },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "pt-2 title-activity",
                                attrs: { slot: "header" },
                                slot: "header"
                              },
                              [_vm._v(" " + _vm._s(activityUser) + " ")]
                            ),
                            _c(
                              "vs-table",
                              {
                                staticClass: "wrap-table",
                                attrs: {
                                  stripe: "",
                                  data: activityUser || [],
                                  noDataText: "No hay actividades aun"
                                }
                              },
                              [
                                _c("template", { slot: "header" }),
                                _c(
                                  "template",
                                  { slot: "thead" },
                                  [
                                    _c("vs-th", [_vm._v(" Actividad ")]),
                                    _c("vs-th", [_vm._v(" Estado ")]),
                                    _c("vs-th", [_vm._v(" Fecha ")])
                                  ],
                                  1
                                ),
                                [
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.activitiesHistory[activityUser],
                                      function(activity, index) {
                                        return _c(
                                          "vs-tr",
                                          { key: index },
                                          [
                                            _c("vs-td", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    activity.actividadDescripcion
                                                  ) +
                                                  " "
                                              )
                                            ]),
                                            _c("vs-td", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    activity.actividadEstadoDescripcion
                                                  ) +
                                                  " "
                                              )
                                            ]),
                                            _c("vs-td", [
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("dateFormatTime")(
                                                      activity.fechaCreacion
                                                    )
                                                  )
                                                )
                                              ])
                                            ])
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                ]
                              ],
                              2
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            !_vm.sortByUsers
              ? _c(
                  "div",
                  { staticClass: "py-2 box-activities" },
                  [
                    _c(
                      "vs-table",
                      {
                        staticClass: "wrap-table",
                        attrs: {
                          stripe: "",
                          data: _vm.activitiesHistoryDates || [],
                          noDataText: "No hay actividades aun"
                        }
                      },
                      [
                        _c("template", { slot: "header" }),
                        _c(
                          "template",
                          { slot: "thead" },
                          [
                            _c("vs-th", [_vm._v(" Actividad ")]),
                            _c("vs-th", [_vm._v(" Estado ")]),
                            _c("vs-th", [_vm._v(" Fecha ")])
                          ],
                          1
                        ),
                        [
                          _c(
                            "tbody",
                            _vm._l(_vm.activitiesHistoryDates, function(
                              activity,
                              index
                            ) {
                              return _c(
                                "vs-tr",
                                { key: index },
                                [
                                  _c("vs-td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(activity.actividadDescripcion) +
                                        " "
                                    ),
                                    _c("div", [
                                      _c("small", [
                                        _vm._v(_vm._s(activity.usuarioNombre))
                                      ])
                                    ])
                                  ]),
                                  _c("vs-td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          activity.actividadEstadoDescripcion
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c("vs-td", [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("dateFormatTime")(
                                            activity.fechaCreacion
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ]
                      ],
                      2
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }